"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upgradePageEntriesIntoParts = upgradePageEntriesIntoParts;
const page_document_maps_1 = require("./page-document-maps");
const page_structure_entry_1 = require("./page-structure-entry");
const page_upgrade_entry_1 = require("./page-upgrade-entry");
/** Moves the single-document format-3 structure to implicit part ownership. */
function upgradePageEntriesIntoParts(doc) {
    const structure = (0, page_document_maps_1.pageStructureMap)(doc);
    const entries = [...structure].map(([id, value]) => {
        const raw = (0, page_upgrade_entry_1.readPageUpgradeEntry)(id, value);
        return [
            id,
            (0, page_structure_entry_1.encodePageStructureEntry)({ ...raw, s: page_document_maps_1.PAGE_DOCUMENT_PART_ID }),
        ];
    });
    for (const [id, entry] of entries)
        structure.set(id, entry);
}
